module.exports = __webpack_public_path__ + "assets/icon-animalType-cow.45b5aaf2.svg";